import { UpdatePropertyTypeTemplateComponent } from './update-property-type-template/update-property-type-template.component'
import { CreatePropertyTypeTemplateComponent } from './create-property-type-template/create-property-type-template.component'
import { PropertyTypeTemplatesComponent } from './property-type-templates.component'
import { MainLayoutComponent } from '../../components/main-layout/main-layout.component'
import { Routes } from '@angular/router'
import { AuthGuard } from 'src/app/guards/auth.guard'
import { NgxPermissionsGuard } from 'ngx-permissions'

export const propertyTypeTemplatesRoutes: Routes = [
  {
    path: 'admin/property-type-templates',
    component: MainLayoutComponent,
    canActivate: [AuthGuard, NgxPermissionsGuard],
    data: {
      permissions: {
        only: 'SYSTEM_CONFIGURATION_PANEL',
        redirectTo: '/',
      },
    },
    children: [
      {
        path: '',
        component: PropertyTypeTemplatesComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: 'create',
        component: CreatePropertyTypeTemplateComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
      {
        path: ':id/update',
        component: UpdatePropertyTypeTemplateComponent,
        data: {
          permissions: {
            only: 'SYSTEM_CONFIGURATION_PANEL',
            redirectTo: '/',
          },
        },
      },
    ],
  },
]
